export const routes = {
  home: "/",
  ducted: "/rinnai-ducted-air-conditioning-perth",
  split: "/rinnai-split-system-air-conditioning-perth",
  izone: "/izone-smart-air-conditioning-perth",
  whyRinnai: "/why-rinnai",
  whyUs: "/why-us",
  faqs: "/faqs",
};

export const navigation = [
  { label: "Rinnai Ducted", to: "/rinnai-ducted-air-conditioning-perth" },
  { label: "Split Systems", to: "/rinnai-split-system-air-conditioning-perth" },
  { label: "iZone", to: "/izone-smart-air-conditioning-perth" },
  { label: "Why Rinnai", to: "/why-rinnai" },
  { label: "Why Us", to: "/why-us" },
  { label: "FAQs", to: "/faqs" },
];

export const relatedPages = [
  {
    to: "/rinnai-ducted-air-conditioning-perth",
    title: "Rinnai Ducted Air Conditioning",
    text: "Whole-home heating and cooling from one hidden system, with up to 8 zones.",
  },
  {
    to: "/rinnai-split-system-air-conditioning-perth",
    title: "Rinnai Split Systems",
    text: "Efficient reverse cycle comfort for bedrooms, living areas and home offices.",
  },
  {
    to: "/izone-smart-air-conditioning-perth",
    title: "iZone Smart Control",
    text: "Room-by-room control for up to 14 zones, from your phone or voice assistant.",
  },
  {
    to: "/why-rinnai",
    title: "Why Rinnai",
    text: "50+ years in Australian homes, a 7 year warranty and national 1stCare service.",
  },
  {
    to: "/why-us",
    title: "Why Perth Home Air Conditioning",
    text: "30+ years in Perth, ARC Tick licensed installers and a dedicated Rinnai focus.",
  },
  {
    to: "/faqs",
    title: "Air Conditioning FAQs",
    text: "Straight answers on sizing, costs, zoning, installation and service.",
  },
];
